import createActions from '@/common/store/modules/common/common.actions';
import createGetters from '@/common/store/modules/common/common.getters';
import mutations from '@/common/store/modules/common/common.mutations';
import { CommonState } from '@/common/store/modules/common/types/CommonState';
import { ActionsArgs } from '@/common/store/modules/common/types/ActionArgs';
import { DEFAULT_REQUEST_VIEW, addRequestView } from './common.constants';

// Cannot pass type yet in createCommonModule since not all modules are moved to ts
const createCommonModule = (options: ActionsArgs<any>): CommonStore<CommonState, typeof options.Model> => {
  const commonActions = createActions<typeof options.Model>(options);

  const getInitialState = (): CommonState => ({
    itemsMap: {},
    runningActions: {},
    errors: {},
    availableActions: Object.keys(commonActions),
    viewLists: {
      [DEFAULT_REQUEST_VIEW]: addRequestView()
    },
    ...options.state
  });

  return new class implements CommonStore<CommonState, typeof options.Model> {
    namespaced = true;
    name = options.name; // name used in dynamic creation/deletion
    state = getInitialState();
    getters = {
      ...createGetters<typeof options.Model>(options),
      ...options.getters
    };

    actions = commonActions;
    mutations = {
      ...mutations(getInitialState),
      ...options.mutations
    };
  }();
};

export default createCommonModule;
